<template>
  <md-dialog-alert
    class="new"
    :md-fullscreen="false"
    @md-opened="scroll('locked')"
    @md-closed="
      scroll('clear')
      scrollTo()
    "
    :md-active.sync="$store.state.screen.isInfo"
    :md-content="`<strong>${$store.state.screen.modalMessage}</strong>`"
  />
</template>
<script>
// import Store from '@/store/index.js'
import Mixin from '@/components/mixin/Mixin'
export default {
  name: 'Info',
  mixins: [Mixin],
  methods: {
    scrollTo() {
      if (!this.$store.state.screen.isScroll) return
      this.scrollToErr()
    },
  },
}
</script>

<style lang="sass" scoped>
@import '../assets/css/logico2'
.md-dialog
  width: auto
  z-index: 1000
</style>



// WEBPACK FOOTER //
// src/components/Info.vue